import R from 'app/assets/R'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { useHookTable } from './hook'
import { BaseRow } from 'app/components/common/BaseRow'
import { Create } from './components/Create'
import { FilterManagement } from '../DegreeManagement/components/FilterManagementTable'
const DegreeManagementContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    fetchNewData,
    filter,
    handleChangeFilter,
    industries,
  } = useHookTable()
  return (
    <S.BaseManagementWrapper>
      <HeaderPage
        titleI18nKey={R.strings.degree_content_management}
        isExport
        rightComponent={<Create fetchTable={fetchNewData} />}
      />
      <S.RootWrapper>
        <BaseRow>
          <FilterManagement
            handleChangeFilter={handleChangeFilter}
            filterData={filter}
            industries={industries}
          />
        </BaseRow>
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default DegreeManagementContainer
